import { BANK_POPUP_DETAILS } from "./constant";

export const getPopupDetails = (isVerified = false, showSelfBought, isMismatchAccepted) => {
    if ((showSelfBought && isMismatchAccepted) || isVerified) return BANK_POPUP_DETAILS.BANK_VERIFIED;
    return  BANK_POPUP_DETAILS.BANK_UNDER_VERIFICATION;
};
